import type AboutCandidateView from '@UI/Store/Subjects/Views/AboutCandidateView';

/** The candidates found for one search. */
class AboutCandidatesListView {
	readonly search: string;
	readonly candidates: readonly AboutCandidateView[];

	constructor(search: string, candidates: readonly AboutCandidateView[]) {
		this.search = search;
		this.candidates = candidates;

		Object.freeze(this);
	}
}

export default AboutCandidatesListView;
